import React from 'react'
import { NavLink } from 'react-router-dom';

function Features() {
    return (
        <>
            <div className='Features-Main-Content'>
                <div className='Features-Card'>
                    <div className='Features-Card-1'>
                        <NavLink to="">
                            <span><i className="fa-solid fa-book"></i></span>
                            <p>Registration for Admission</p>
                        </NavLink>
                    </div>
                   
                    <div className='Features-Card-1'>
                        <NavLink to="/fees-instructions">
                            <span><i className="fa-solid fa-hands-asl-interpreting"></i></span>
                            <p>Fees Structure</p>
                        </NavLink>
                    </div>
                    <div className='Features-Card-1'>
                        <NavLink to="/contacts">
                            <span><i className="fa-solid fa-envelope"></i></span>
                            <p>Enquire Now</p>
                        </NavLink>
                    </div>
                </div>
            </div>
        </>
    )
}

export default Features;